<template>
  <h1>InputDiagnosis<span v-if="!loaded"> (loading..)</span></h1>

  <div v-if="loaded" class="row">
    <input-diagnosis v-model="current" @continue="triggerEvent('continue')" />
  </div>

  <div class="row">
    <p><strong>Current value:</strong> {{ current ? current : '(none)' }}</p>
    <p><strong>Has value:</strong> {{ hasValue ? 'True' : 'False' }}</p>
    <button class="btn btn-success" @click="randomizeValue">
      Randomize value
    </button>

    <event-ticks :events="events" :events-active="eventsActive" class="mt-4" />
  </div>
</template>

<script>


import { mapState } from 'pinia';
import { useSurveyStore } from '@/store';
import InputDiagnosis from './InputDiagnosis.vue';
import DevComponentContainer from '../../DevComponent/DevComponentContainer';
import { pickRandom } from '@/utils/arrayUtil';
import EventTicks from '../../DevComponent/EventTicks';
import EventTicksComponentMixin from '../../DevComponent/EventTicksComponentMixin';

export default {
  name: 'InputDiagnosisDev',
  components: { InputDiagnosis, EventTicks },
  extends: DevComponentContainer,
  mixins: [EventTicksComponentMixin],
  data() {
    return {
      current: null,
      loaded: false,

      events: ['continue'],
    };
  },
  computed: {
    ...mapState(useSurveyStore, ['diagnosisCategories']),
    hasValue() {
      return this.current !== null && this.current.length > 0;
    },
  },
  mounted() {
    if (!this.diagnosisCategories || !this.diagnosisCategories.length) {
      this.$apiClient.misc.getGameData().then((gameData) => {
        console.log('gameData.diagnosisCategories', gameData.diagnosisCategories);
        useSurveyStore().setDiagnosisCategories(gameData.diagnosisCategories);

        this.randomizeValue();

        this.$nextTick(() => {
          this.loaded = true;
        });
      });
    } else {
      this.loaded = true;
    }
  },
  methods: {
    randomizeValue() {
      const current = [];
      const maxReturnedItems = 10;

      for (const diagnosisCategory of this.diagnosisCategories) {
        for (const diagnosis of diagnosisCategory.items) {
          if (current.length >= maxReturnedItems) {
            break;
          }

          if (Math.random() <= 0.5) {
            current.push(diagnosis.id);
          }
        }
      }

      this.current = current;
    },
  },
};
</script>
